import { createContext, useContext } from "react"

import { capture } from "~/client/posthog.client"

// Click tracking for the conquest page's blocks, in a file of its own so a
// block used on another page (the home page's voices, the blog post's
// questions) doesn't pull in the conquest page's sections with it.

// Which page a tracked click came from, as the `variant` property (one
// event name for all CTAs). The conquest page sets "alternative", the home
// page "home"; a block used anywhere else (the blog post's questions card)
// reports "other".
export const VariantContext = createContext("other")

// The booking form at the foot of the page (BookMeeting): every main CTA
// scrolls here instead of leaving for /get-started.
export const BOOK_ID = "book-a-meeting"

export function useTrack() {
  const variant = useContext(VariantContext)
  return (location: string, extra?: Record<string, unknown>) => () =>
    capture("explore_data_clicked", { location, variant, ...extra })
}
